import { Component, OnInit, ViewChild } from '@angular/core';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent, TableColumnDefinition } from 'src/app/components/base.component';
import { NgForm } from '@angular/forms';
import { Transfer, TransferResult } from 'src/app/models/shortcodes.model';
import { ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { CodeTransferDialogComponent } from '../code-transfers/transfer-dialog/code-transfer-dialog.component';
import { AcceptDeclineDialogComponent } from '../code-transfers/accept-decline-dialog/accept-decline-dialog.component';
import { Router } from '@angular/router';
import { TransferAccept } from 'src/app/models/shortcodes.model';
import { BadgeService } from 'src/app/services/badge.service';
import { ScrBaseResponse, ScrBaseService } from 'src/app/services/base.service';

export interface TransferEvent {
  type: string;
  response: ScrBaseResponse;
  scId: number;
}
@Component({

  templateUrl: './code-transfers.component.html',
  styleUrls: ['./code-transfers.component.scss']
})
export class CodeTransfersComponent extends ScrBaseComponent implements OnInit {
  incomingTransferList: Transfer[] = [];
  outgoingTransferList: Transfer[] = [];
  isDisplay = false;
  shortCodeValue!: string;
  searchShortCodeValue!: number;
  fromAccountID = '';
  companyName = '';
  leaseType = '';
  mbOptOutDate = '';
  leaseStatus = '';
  MonthlyBillingEnabled = '';
  leaseTerm?: number;
  expirationDate = '';
  transferId!: string;
  transferStatus!: string;
  transferAccept = new TransferAccept();
  isSCCustomError = false;
  isSCCustomErrorMessage?: string;
  isSuccessVisible = false;
  isSuccessLink = false;
  successSdId?: number;
  preMessage = "";
  postMessage = "";
  currentPage = 0;
  totalIncomingTransferRecords = 0;
  totalOutgoingTransferRecords = 0;
  inoutgoingList = false;
  incomingTransferPage = 1;
  outgoingTransferPage = 1;
 
  incomingCols: TableColumnDefinition[] = [
    { field: 'scId', header: 'Short Code' },
    { field: 'transferStatus', header: 'Transfer Status' },
    { field: 'fromAccountId', header: 'From Account' },
    { field: 'fromCompany', header: 'From Organization' },
    { field: 'initiatedDate', header: 'Initiated Date' },
    { field: 'respondedDate', header: 'Accepted Date' },
    { field: 'respondedBy', header: 'Accepted by' },
    { field: 'createTime', header: '', width: 18 }
  ];
  outgoingCols: TableColumnDefinition[] = [
    { field: 'scId', header: 'Short Code' },
    { field: 'transferStatus', header: 'Transfer Status' },
    { field: 'toAccountId', header: 'To Account' },
    { field: 'toCompany', header: 'To Organization' },
    { field: 'initiatedDate', header: 'Initiated Date' },
    { field: 'initiatedBy', header: 'Initiated by' },
    { field: 'respondedDate', header: 'Accepted Date' },
    { field: 'createTime', header: '' }
  ];
  
  @ViewChild('transferForm', { static: false }) transferForm!: NgForm;
  @ViewChild(CodeTransferDialogComponent, { static: false }) dialog!: CodeTransferDialogComponent;
  @ViewChild(AcceptDeclineDialogComponent, { static: false }) acceptDialog!: AcceptDeclineDialogComponent;

  constructor(private shortCodesService: ShortCodesService,
    private badgeService: BadgeService,
    private confirmationService: ConfirmationService,
    private router: Router) { super(); }

  ngOnInit(): void {
   // this.shortCodesService.getIncomingAndOutgoingTransfers().subscribe(rsp => {
    this.getIncomingAndOutgoingTransfers(1,1);
  }


  loadLazyIncomingTransferList(event: LazyLoadEvent) {
  
    this.currentPage = (event.first ?? 0) / (event.rows ?? 0) + 1;
    this.incomingTransferPage = this.currentPage;
    this.observe(this.shortCodesService.getIncomingTransferList(this.currentPage, 30), rsp => {
     this.incomingTransferList = rsp.incomingTransfer.transfer;
      this.isDisplay = true;
      this.totalIncomingTransferRecords = rsp.incomingTransfer.totalCount;
      this.updateCache(this.totalIncomingTransferRecords + this.totalOutgoingTransferRecords);
      return false; // don't display success.

    });
  }


  loadLazyOutgoingTransferList(event: LazyLoadEvent) {
  
    this.currentPage = (event.first ?? 0) / (event.rows ?? 0) + 1;
    this.outgoingTransferPage = this.currentPage;
    this.observe(this.shortCodesService.getOutgoingTransferList(this.currentPage, 30, undefined), rsp => {
     this.outgoingTransferList = rsp.outgoingTransfer.transfer;
      this.isDisplay = true;
      this.totalOutgoingTransferRecords = rsp.outgoingTransfer.totalCount;
      this.updateCache(this.totalIncomingTransferRecords + this.totalOutgoingTransferRecords);
      

      return false; // don't display success.

    });
  }


  

  acceptDeclineTransfer(scId: number, fromAccountID: string, companyName: string, leaseType: string, leaseStatus: string, isMonthlyBillingEnabled: string, leaseTerm: number, expirationDate: string, transferId: string, transferStatus: string, mbOptOutDate: string) {

    this.fromAccountID = fromAccountID;
    this.companyName = companyName;
    this.searchShortCodeValue = scId;
    this.leaseStatus = leaseStatus;
    this.leaseType = leaseType;
    this.mbOptOutDate = mbOptOutDate;
    this.MonthlyBillingEnabled = isMonthlyBillingEnabled === undefined ? "0" : isMonthlyBillingEnabled.toString();
    this.expirationDate = expirationDate;
    this.acceptDialog.display = true;
    this.leaseTerm = leaseTerm;
    this.transferId = transferId;
    this.transferStatus = transferStatus;
    this.acceptDialog.resetfrom();
  }

  public directDeclineConfirmation(scId: string, fromAccountID: string, transferID: string) {
    this.confirmationService.confirm({
      message:
        'The transfer of short code ' + scId + ' into your account from Account ID ' + fromAccountID + ' has already been accepted but is not yet complete. Are you sure you want to decline the transfer?',
      header: 'Decline Transfer',
      key: 'declineTransferConfirmation',
      accept: () => {
        this.processDecline(parseInt(transferID));
      }
    });
  }
  processDecline(transferID: number) {
    this.observe(this.shortCodesService.declineTransfer(transferID), {
      onSuccess: () => {
        this.closeSuccesses();
        this.refreshOutgoingTransfer();
      }
    });
  }

  public cancelTransfer(shortCode: string, toAccountId: string, transferId: number) {

    this.confirmationService.confirm({
      message:
        'Do you want to cancel the transfer of short code ' + shortCode + ' from your account to Account ID ' + toAccountId + '?',
      header: 'Cancel Transfer',
      key: 'cancelTransfer',
      accept: () => {
        this.observe(this.shortCodesService.cancelTransfer(transferId), {
          onSuccess: () => {
            this.closeSuccesses();
            this.refreshOutgoingTransfer();
          }
        });
      }
    });
  }

  refreshOutgoingTransfer() {
  /*  this.observe(this.shortCodesService.getIncomingAndOutgoingTransfers(), res => {
      this.outgoingTransferList = res.outgoingTransfer.transfer;
      this.incomingTransferList = res.incomingTransfer.transfer;
      this.updateCache(res.incomingTransfer.totalCount + res.outgoingTransfer.totalCount);
      return false;
    });*/
    this.getIncomingAndOutgoingTransfers(this.incomingTransferPage, this.outgoingTransferPage);

  }

  getIncomingAndOutgoingTransfers(incomingTransferPage: number, outgoingTransferPage: number){
    this.forkedObserve<TransferResult>([
      this.shortCodesService.getIncomingTransferList(incomingTransferPage,30),
      this.shortCodesService.getOutgoingTransferList(outgoingTransferPage,30, undefined),
     ], (rsp) => {

      this.incomingTransferList =  rsp[0].incomingTransfer.transfer;
      this.outgoingTransferList = rsp[1].outgoingTransfer.transfer;
      this.isDisplay = true;
      this.totalIncomingTransferRecords =  rsp[0].incomingTransfer.totalCount;
      this.totalOutgoingTransferRecords =  rsp[1].outgoingTransfer.totalCount;
     
      this.updateCache( this.totalIncomingTransferRecords + this.totalOutgoingTransferRecords );

      /*
        uncomment this to test the display of the success message without doing a transfer.
        this.isSuccessVisible = true;
        this.preMessage = "The transfer of short code ";
        this.postMessage = " into your account has been accepted, and is in the process of being completed by Customer Support. You will receive an email when the transfer is complete.";
        this.successSdId = 20202;
        this.isSuccessLink = true;
      */

      return false;
    });
  }

  showShortCodeTransferDialog(form: NgForm) {
    this.isSCCustomError = false;
    this.inoutgoingList = false;
    form.controls['shortCode'].markAsTouched();
    if (!form.valid) {
      this.scrollToFirstError();
      return;
    }
    this.searchShortCodeValue = parseInt(ScrBaseService.shortCodeToNumeric(this.shortCodeValue));
    this.observe(this.shortCodesService.getOutgoingTransferList(1, 1, this.searchShortCodeValue), rsp => {
  
    
      if(rsp.outgoingTransfer.transfer.length > 0){
      //if (this.outgoingTransferList.some(element => element.scId.toString() === this.shortCodeValue)) {
        this.isSCCustomErrorMessage = "This short code is already in the Outgoing Transfers list.";
        this.isSCCustomError = true;
        this.inoutgoingList = false;
        const elmt = document.getElementById('messages');
        elmt?.scrollIntoView({ behavior: "smooth" });
       // return ;
      }else {
        this.inoutgoingList = true;
        this.dialog.display = true;
        this.dialog.resetForm();
      }
       
      return false;
    });

      if (ScrBaseService.isInvalidShortCode(this.shortCodeValue)) {
        this.isSCCustomErrorMessage = "The short code must be 5 or 6 alpha-numeric characters and in the numerical range 20000 ~ 99999 or 200000 ~ 999999";
        this.isSCCustomError = true;
        const elmt = document.getElementById('messages');
        elmt?.scrollIntoView({ behavior: "smooth" });
        return;
      }


      if(this.inoutgoingList){
       this.dialog.display = true;
       this.dialog.resetForm();
       
      }

  }

  transferEventHandler(e: TransferEvent) {
    if (e.type === "Success") {
      if (e.response.messages && e.response.messages[0].code === "6205") {
        this.isSuccessLink = true;
        this.preMessage = "The transfer of short code ";
        this.postMessage = " into your account has been completed.";
      }
      else if (e.response.messages && e.response.messages[0].code === "6202") {
        this.isSuccessLink = false;
        this.preMessage = "The transfer of short code ";
        this.postMessage = " into your account has been accepted, and is in the process of being completed by Customer Support. You will receive an email when the transfer is complete.";
      }
      else if (e.response.messages && e.response.messages[0].code === "6340") {
        this.isSuccessLink = false;
        this.preMessage = "The transfer of short code ";
        this.postMessage = " was initiated and accepted however the short code is waiting for renewal. The transfer will complete once the renewal is complete.";
      }
      else if (e.response.messages && e.response.messages[0].code === "6341") {
        this.isSuccessLink = false;
        this.preMessage = "The transfer of short code ";
        this.postMessage = " was initiated and accepted however the short code is currently on an open invoice. The transfer will complete once the invoice is paid.";
      }
      else {
        this.isSuccessLink = false;
        this.preMessage = "The transfer of short code ";
        this.postMessage = ' is partially completed.  ' + this.getFirstMessage(e.response);
      }
      this.successSdId = e.scId;
      this.displayScuess();
    }
    if (e.type === "decline") {
      const msg = this.getFirstMessage(e.response);
      if (msg) {
        this.displaySuccessMessage('Success', msg);
      }
    }

    this.dialog.display = false;
    this.refreshOutgoingTransfer();
    this.shortCodeValue = '';
    this.transferForm.resetForm();
    this.transferForm.form.markAsPristine();
  }

  shortCodeKeyPress() {
    this.isSCCustomError = false;
  }
  navigateReports() {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['reports'] } }]);
  }

  closeSuccesses() {
    this.isSuccessVisible = false;
  }

  displayScuess() {
    this.isSuccessVisible = true;
    setTimeout(() => {
      this.isSuccessVisible = false;
    }, 20000);
  }

  navigateLookup() {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }], { state: { scId: this.successSdId } });
    //this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-lookup'] } }] } }], { state: { shortCode: this.successSdId } });
  }

  updateCache(count: number) {
    this.badgeService.updateLocally(data => {
      if (data.transfersCount !== count) {
        const previous = data.transfersCount;
        data.transfersCount = count;
        this.log.debug('transfers count updated from ' + previous + ' to ' + data.transfersCount);
        return data;
      }
      return undefined;
    });
  }
}
